import graphQLClient from '@seek/hirer-graphql-client';
import { getToken, redirectToLogin } from 'src/modules/authHandler';
import debug from 'debug';
import memoize from 'lodash/memoize';
import { cache } from 'src/gql/client-side/cache';
import { getEnvironment, getSite } from '../../../config';
import { Environment } from '../../../types';
import { HIRER_GRAPHQL_STAGING } from '../../../constants/urls';

const createDebug = memoize((name: string) => debug(`hirerGql:${name}`));

const sharedConfig = {
  appName: 'branding-tool',
  site: getSite(),
  logMetrics: createDebug('logMetrics'),
  logGraphQLError: createDebug('logGraphQLError'),
  logError: createDebug('logError'),
  cache,
  login: () => {},
  getAuthToken: () => Promise.resolve(''),
  renewAuthToken: () => Promise.resolve(''),
  uri:
    getEnvironment() === Environment.DEV ? HIRER_GRAPHQL_STAGING : '/graphql',
};

export const hirerGqlClient = graphQLClient({
  ...sharedConfig,
  login: redirectToLogin,
  getAuthToken: getToken,
  renewAuthToken: getToken,
});
